import { useEffect, useState } from "react";

import errorResolver from "../../utils/error-resolver";
import { PbxServerSchema } from "../../services/Schemas/PbxServer";
import { useProtectedAxiosInstance } from "../../hooks/axiosInstance";
import { useNotificationContext } from "../../context/notificationContext";
import PbxServerStatusCard from "../../components/panel/report/PbxServerStatusCard";
import { PbxServersListRequest } from "../../services/Endpoints/pbxserver/PbxServerListEndpoint";

import { useParams } from "react-router-dom";
import { Stack, Typography } from "@mui/material";

export default function PbxServerDetailsPage() {

  const [waiting, setWaiting] = useState(false);
  const [partner, setPartner] = useState<PbxServerSchema | null>(null);
  
  const { id } = useParams();
  const { setNotification } = useNotificationContext();
  const protectedInstance = useProtectedAxiosInstance();
  
  const getData = async () => {
    try {
      setWaiting(true);
      const pbxServerListRequest = new PbxServersListRequest(protectedInstance);
      const resp = await pbxServerListRequest.details(id ? +id : 1);
      setPartner(resp.data.pbxServer);
      setWaiting(false);
    } catch (error) {
      errorResolver({ error, setNotification });
      setWaiting(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Stack mt={5} width={"100%"} px={5}>
      {waiting ? (
        <Typography>در حال دریافت اطلاعات ...</Typography>
      ) : (
        <>
          {partner && (
            <PbxServerStatusCard partner={partner} refreshInterval={10} />
          )}
        </>
      )}
    </Stack>
  );
}
